// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PGYJ","badges":"styles_badges__mjOfE"};